import styled from 'styled-components';

const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  align-content: flex-start;
  margin: 10px;
  width: 80vw;
  min-width: 320px;
  max-width: 450px;
  height: 200px;
  border-radius: 2.5px;
  color: white;
  font-size: 18px;
  text-align: left;
`
export default Section;